import React from 'react';
import { Typography } from '@mui/material';
import { StyledImportantTag } from './index.style';

const ImportantTagNew = ({
  tag,
  bgColor,
  color,
  colorText,
  left,
  top,
  padding,
  borderRadius,
  tagIcon: TagIcon,
}) => (
  <StyledImportantTag
    bgColor={bgColor}
    color={color}
    colorText={colorText}
    left={left}
    top={top}
    padding={padding}
    borderRadius={borderRadius}
  >
    <Typography
      className="new-label-text"
      sx={{ display: 'flex', alignItems: 'center' }}
    >
      {TagIcon && <TagIcon sx={{ width: 16, height: 16, paddingRight: 0.5 }} />}
      {tag}
    </Typography>
  </StyledImportantTag>
);

export default ImportantTagNew;
